import type { ColTypeDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { TradeAuthorizationStatusCellRenderer } from '../CellRenderers';

export function useTradeAuthorizationStatusColumnType<T>(useSetColumnFilter?: boolean): ColTypeDef<T> {
  return useMemo(() => {
    const filter = useSetColumnFilter ? 'agSetColumnFilter' : 'agTextColumnFilter';

    return {
      cellRenderer: TradeAuthorizationStatusCellRenderer,
      filter,
    };
  }, [useSetColumnFilter]);
}

export function useServerSideTradeAuthorizationStatusColumnType<T>(): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: TradeAuthorizationStatusCellRenderer,
    }),
    [],
  );
}
